import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { authApi } from '@/api/endpoints/auth'
import { Card } from '@/components/common/UI/Card'
import { Spinner } from '@/components/common/UI/Spinner'

export default function VerifyEmail() {
  const [params] = useSearchParams()
  const userId = Number(params.get('user_id'))
  const token = params.get('token') || ''
  const [state, setState] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('Проверяем ссылку подтверждения…')

  useEffect(() => {
    if (!Number.isInteger(userId) || userId < 1 || !token) {
      setState('error')
      setMessage('Ссылка подтверждения неполная или некорректная.')
      return
    }
    authApi.verifyEmail(userId, token)
      .then(() => { setState('success'); setMessage('Email подтверждён. Теперь можно войти в аккаунт.') })
      .catch((error: any) => {
        setState('error')
        setMessage(error.response?.data?.detail || 'Ссылка недействительна или срок её действия истёк. Попросите администратора отправить письмо повторно.')
      })
  }, [token, userId])

  return <main className="container-custom flex min-h-[60vh] items-center justify-center py-12"><Card className="w-full max-w-lg p-8 text-center">
    {state === 'loading' && <Spinner size="lg" className="mx-auto" />}
    {state !== 'loading' && <div className={`mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full text-2xl ${state === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>{state === 'success' ? '✓' : '!'}</div>}
    <h1 className="text-2xl font-bold">{state === 'success' ? 'Email подтверждён' : state === 'error' ? 'Не удалось подтвердить email' : 'Подтверждение email'}</h1>
    <p className="mt-3 text-secondary-600">{message}</p>
    {state !== 'loading' && <Link to="/login" className="mt-6 inline-flex rounded-lg bg-primary-600 px-5 py-2.5 font-semibold text-white hover:bg-primary-700">Перейти ко входу</Link>}
  </Card></main>
}
